import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { TooltipComponent } from '@infinitform/shared-ui';
import { TooltipDirective } from './tooltip.directive';
import { TooltipService } from './tooltip.service';

@NgModule({
  imports: [
    OverlayModule,
    PortalModule,
    TooltipComponent,
    TooltipDirective
  ],
  exports: [
    TooltipComponent,
    TooltipDirective
  ],
  providers: [
    TooltipService
  ]
})
export class TooltipModule { }
